import {useQuery} from "@tanstack/react-query";
import React from "react";
import {BasicSearchType} from "../../../../../types/common/basic";
import {readSystemUserListApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = { searchData: BasicSearchType };

const useReadSystemUserList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readSystemUserList", searchData],
        queryFn: async () => await readSystemUserListApi(searchData),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
    });
    return {data};
};

export default useReadSystemUserList;
